/**
 * External dependencies
 */
import inherits from 'inherits';

export default class DispatchPlan {
    
    constructor(cscom) {
        if (!(this instanceof DispatchPlan)) {
            return new DispatchPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/dispatch-plans/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/dispatch-plans/view', null, data);
    }    
}
